import { Component, ViewEncapsulation, Input } from '@angular/core';
import { SharedService } from 'app/layout/shared/shared.service';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from 'app/layout/shared/loader.service';
import { FormControl, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
    selector: 'stime-picker',
    templateUrl: 'NewTimePicker.component.html',
    styleUrls: ['./NewTimePickerStyle.css'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: NewTimePickerComponent, multi: true }
    ],
})
export class NewTimePickerComponent implements ControlValueAccessor {
    mytimePicker = new FormControl('');
    mytime = new FormControl('');
    hdnContr = new FormControl('');
    isHtmlSupport: boolean;
    error: boolean = false;
    @Input() isDisabled: boolean = false;

    writeValue(obj: any): void {
        this.hdnContr.setValue(obj ? this.dateValidate(obj, true) : this.clearControls());
    }

    clearControls(): any {
        this.mytime.setValue(null);
        this.mytimePicker.setValue(null);
        return null;
    }
    dateValidate(obj: Date, inilize: boolean = false): Date {
        if (obj) {
            let h: number = obj.getHours();
            let m: number = obj.getMinutes();
            let o: string = "";
            if (h >= 12)
                o = ((h == 12) ? 12 : (h - 12)) + ":" + m + " pm";
            else
                o = h + ":" + m + " am";
            this.mytimePicker.setValue(o);
            this.hdnContr.setValue(obj);
            if (inilize) {
                let hr: string = (h < 10) ? ("0" + h) : (h + "");
                let mi: string = (m < 10) ? ("0" + m) : (m + "");
                this.mytime.setValue((hr + ":" + mi));
            }
        }
        return new Date(obj);
    }

    registerOnChange(fn: any): void {
        this.hdnContr.valueChanges.subscribe(fn);
    }
    registerOnTouched(fn: any): void {

    }
    setDisabledState?(isDisabled: boolean): void {

    }

    ngOnInit() {       
        this.isHtmlSupport = this.CheckIEBrowser();
    }

    CheckIEBrowser() {
        let colorInput: HTMLInputElement;
        colorInput = document.createElement("input");
        colorInput.setAttribute('type', 'color');
        colorInput.setAttribute('value', '!');
        return colorInput.type === 'color' && colorInput.value !== '!';
    }

    constructor(protected sharedService: SharedService, protected translate: TranslateService, private loaderservice: LoaderService) {
        // document.addEventListener('click', this.offClickHandler.bind(this)); // bind on doc 
    }

    offClickHandler(event: any) { }

    changeDate(obj: string) {
        debugger;
        let d = obj.split(" ");
        let a = d[1];
        let t = d[0].split(":")[0];
        let m = d[0].split(":")[1];
        let o = null;
        if (a == "pm") {
            let r: string = (12 + parseInt(t)).toString();
            if (r == "24") r = "12";
            o = (r + ":" + m);
        }
        else {
            if (t == "12")
                t = "00";
            o = (t + ":" + m);
        }
        if (this.isHtmlSupport)
            this.mytime.setValue(o);
        else
            this.mytime.setValue(obj);
        this.hdnContr.setValue(new Date(new Date().toDateString() + ' ' + obj));
    }

    changeTime(obj: any) {
        debugger;
        if (obj.target.value != "")
            this.dateValidate(new Date(new Date().toDateString() + ' ' + obj.target.value));
        else
            this.hdnContr.setValue(null);
    }

    blurEvent(obj: any) {
       this.error = (obj.target.value == "");
    }
}